import { render, staticRenderFns } from "./LeadingTalent.vue?vue&type=template&id=1d95ced3&scoped=true&"
import script from "./LeadingTalent.vue?vue&type=script&lang=js&"
export * from "./LeadingTalent.vue?vue&type=script&lang=js&"
import style0 from "./LeadingTalent.vue?vue&type=style&index=0&id=1d95ced3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95ced3",
  null
  
)

export default component.exports